import useObjectRelationGqlRequest from "./useObjectRelationGqlRequest";
import func from "@uikit/func";
import { useHomeUsePluginContainer } from "./HomeUsePluginRoot";

export default function useHandleChatBox() {
  const { gql } = useObjectRelationGqlRequest();

  const {
    saasAndThinkState: { setSaasUIData, saasUIDataRef },
  } = useHomeUsePluginContainer();

  const setChatBoxParam = async params => {
    const { lineParams, target, edgeId, setNodes, setEdgeLineParam } = params;

    if (lineParams.isChat) {
      const currentParam = await gql.query.objects({
        id: lineParams.identifier.value,
      });
      setNodes(prevNodes => {
        return prevNodes.map(l => {
          if (l.id === target) {
            return {
              ...l,
              data: {
                ...l.data,
                displayType: "chatBox",
                chatBoxParam: currentParam,
              },
            };
          }
          return l;
        });
      });
      setEdgeLineParam({
        id: edgeId,
        loading: false,
      });

      // 如果右侧preview有这个node，应该重新设置引入变量的值
      // bsf-4912 replace thoughts
      const thoughts = saasUIDataRef.current.output;
      if (!func.isEmpty(thoughts)) {
        const newThoughts = thoughts.map(x => {
          return {
            ...x,
            results: x.results.map(y => {
              if (y.nodeId === target) {
                return {
                  ...y,
                  content: {
                    ...y.content,
                    chatBoxParam: currentParam,
                  },
                };
              }
              return y;
            }),
          };
        });
        // bsf-4912 use setSassUIData
        setSaasUIData(prev => ({ ...prev, output: newThoughts }));
      }
      return true;
    } else {
      // 清空chatBoxParam
      setNodes(prevNodes => {
        return prevNodes.map(l => {
          if (l.id === target) {
            return {
              ...l,
              data: {
                ...l.data,
                chatBoxParam: [],
              },
            };
          }
          return l;
        });
      });
    }
    return false;
  };

  return {
    setChatBoxParam,
  };
}
